import Loader from '@components/Loader';
import api from "@utils/api";

const myGamesConsentListIds = [
  "595ff931f1150", "7f26ecea3e65", "9d13bdfa0315",
  "0c24985d0f00", "ee9311694532", "4c378abe92d9",
  "c069784d57d8", "eadcfddbc33a", "382cd760312b2",
  "4ccc0c7a361a", "acb2cd1c8348", "b07bbafef261",
  "ecb6ec7a6fdf", "cf11fc6b5982", "3eeaface669c",
  "96854cba13a8", "cacff9a1a10ea", "adea4a3e7b0d",
  "4f9afabe560a", "aaaf52d3b19ea"
]

export default {
  name: 'ContentTable',
  components: {
    Loader,
  },
  props: {
    lang: {
      type: String,
      default: ""
    },
    messages: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      myGamesConsentUniqList: [],
      loadCookies: true,
      isCollapsed: true,
    };
  },
  mounted() {
    this.getCookiesAll(myGamesConsentListIds, this.getCookies)
      .then(results => {
        this.myGamesConsentUniqList = results
          .flat(2)
          .filter((el => f => !el.has(f.cookiename) && el.add(f.cookiename))(new Set()))
          .sort(((a, b) => a.descr < b.descr ? 1 : -1));
        this.loadCookies = false;
      })
      .catch(e => console.error(e));
  },
  methods: {
    async getCookies(id) {
      return api.get(`https://delivery.consentmanager.net/delivery/cookieinfo.php?cdid=${id}&api=json&l=${this.lang}`);
    },
    getCookiesAll(list, callback) {
      const promises = [];
      list.forEach(el => promises.push(callback(el)));

      return Promise.all(promises);
    },
    handleToggle() {
      this.isCollapsed = !this.isCollapsed;
      if (this.isCollapsed) {
        this.$refs.table.scrollIntoView({behavior: 'smooth'});
      }
    }
  },
};
